export default __webpack_public_path__ + "static/media/bell.1883517f.svg";